// ===== MODELS =====

// User Model
export class UserListAdmin {
  constructor(data = {}) {
    this.id = data.id || null;
    this.email = data.email || '';
    this.fullName = data.fullName || '';
    this.specialization = data.specialization || '';
    this.organizationId = data.organizationId || null;
    this.isActive = data.isActive !== undefined ? data.isActive : true;
    this.isAdmin = data.isAdmin || false;
    this.createdAt = data.createdAt ? new Date(data.createdAt) : null;
    this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : null;
    this.lastLoginAt = data.lastLoginAt ? new Date(data.lastLoginAt) : null;
    this.planType = data.subscription?.planType || null;
    this.status = data.subscription?.status || null;
    this.startDate = data.subscription?.startDate ? new Date(data.subscription.startDate) : null;
    this.endDate = data.subscription?.endDate ? new Date(data.subscription.endDate) : null;
  }
}
